<div *ngIf="!role || role == 'no-role'">
    <h1 class="text-center">We’re sorry</h1>

    <p class="lead" style="text-align: center;">An error has occurred, please try again later.</p>
</div>
<div *ngIf="role && role!=='Agent'">
    <h1 class="text-center">We’re sorry</h1>

    <p class="lead" style="text-align: center;">An error has occurred. Please try again later or contact your insurance agent.</p>
</div>

<div *ngIf="role && role==='Agent'">
    <h1 class="text-center">We’re sorry</h1>

    <p class="lead" style="text-align: center;">An error has occurred. Please try again later or contact the eService Team at (JH_eServices@jhancock.com) for assistance.</p>
</div>
